import logo from './logo.svg';
import './App.css';
import ProfilePage from './Profile-Page';

function App() {
  return (
 <ProfilePage />
  );
}


export default App;
